window.addEventListener("cart_changed", () => {
  setTimeout(() => {
    const listRows = document.querySelectorAll("tr.bss-b2b-qty-table-row");
    if (listRows.length) {
      listRows.forEach((row) => {
        row.addEventListener("click", () => {
          console.log(1);
          row.classList.add("qty-row-active");
        });
      });
    }
  }, 1000);

  const buttonCheckouts = document.querySelectorAll(
    'button[type="submit"][name="checkout"]'
  );
  if (BSS_B2B) {
    if (buttonCheckouts.length) {
      buttonCheckouts.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
        });
      });
    }
  }
});
